module.exports = __webpack_public_path__ + "static/media/swords-laser.546dbb3f.svg";